export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-evernote-3fb260950cdf555b1201698c08fa7788.svg";